'use client';
import React, { PropsWithChildren } from 'react';
import dynamic from 'next/dynamic';
import { useSearchContext } from '../context/SearchProvider';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { SearchResultsProps } from '../types/page';
import useVisitedPage from '../hooks/useInitialPage';
import usePageView from '../hooks/usePageView';
import { AIPanelPage, getPanelOptions } from '../context/AIPanelContext.utils';

const SearchResultsWrapper = dynamic(
  () => import('./search/SearchResultsWrapper'),
  { ssr: false },
);

const WithAIPanel = dynamic(() => import('./ai/WithAIPanel'), { ssr: false });

type Props = PropsWithChildren & {
  searchResultsProps?: SearchResultsProps;
};

/**
 * Wrapper to render search or the page.
 */
const PageChildren = (props: Props) => {
  const { searchResultsProps } = props;
  const { isSearchResultsOpen } = useSearchContext();
  useVisitedPage();
  usePageView();

  return (
    <>
      {/* Render search results */}
      {isSearchResultsOpen && (
        <WithAIPanel
          hideSidebar
          panelOptions={getPanelOptions(AIPanelPage.Search)}
        >
          <SearchResultsWrapper {...searchResultsProps} />
        </WithAIPanel>
      )}
      {/* Render page - hide page but don't unmount for faster rendering */}
      <Box
        className={`w-full ${
          isSearchResultsOpen
            ? 'pointer-events-none fixed h-screen opacity-0'
            : ''
        }`}
      >
        {props.children}
      </Box>
    </>
  );
};

export default PageChildren;
